import request from "@/utils/request";
// 获取项目列表
export function list(data) {
  return request({
    method: "get",
    url: "/project/list",
    // form: data,
    params: data,
    data: {},
  });
}
// 添加项目
export function add(data) {
  return request({
    method: "post",
    url: "/project/add",
    data,
  });
}
// 删除项目
export function del(data) {
  return request({
    method: "get",
    url: "/project/delete",
    params: data,
    data: {},
  });
}
// 修改项目
export function update(data) {
  return request({
    method: "post",
    url: "/project/update",
    data,
  });
}

// 获取盒子数据
export function getBoxData(data) {
  return request({
    method: "post",
    url: "/project/boxdata",
    data,
  });
}

// 获取报表数据
export function getDataReport(data) {
  return request({
    method: "post",
    url: "/project/datareport",
    data,
  });
}
// 添加项目网关信息
export function addBoxInfo(data) {
  return request({
    method: "post",
    url: "/project/addboxinfo",
    data,
  });
}

// 获取项目网关信息
export function getBoxInfo(data) {
  return request({
    method: "post",
    url: "/project/getboxinfo",
    data,
  });
}
// 修改项目位置信息
export function updateProjectPosition(data) {
  return request({
    method: "post",
    url: "/project/updateposition",
    data,
  });
}
